import axios from "axios-config";
import ConsoleHelper from "utils/ConsoleHelper";

export const getProducts = async () => {
  const response = await axios.get(`/app-billing/products`);

  return response.data;
};
